import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight, FiCheck, FiPlay } from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-white">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-slate-50 rounded-l-[100px] -z-10 hidden lg:block" />
      <motion.div 
        animate={{ scale: [1, 1.1, 1], rotate: [0, 5, 0] }}
        transition={{ duration: 20, repeat: Infinity }}
        className="absolute -top-24 -left-24 w-96 h-96 bg-teal-50 rounded-full blur-3xl opacity-60 -z-10" 
      />

      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 text-slate-600 text-xs font-bold uppercase tracking-widest mb-8">
              <span className="flex h-2 w-2 rounded-full bg-teal-500"></span>
              Metropolregion Hamburg
            </div>
            
            <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 leading-[1.1] mb-8">
              Nebenjobs im Norden <br />
              <span className="text-teal-600">einfach & persönlich.</span>
            </h1>
            
            <p className="text-xl text-slate-600 mb-10 leading-relaxed max-w-xl">
              Wir verbinden motivierte Bewerber mit attraktiven Unternehmen in Hamburg. Schnell, regional und ohne komplizierten Papierkram.
            </p>
            
            <div className="flex flex-wrap gap-4 items-center">
              <Link to="/bewerber" className="btn-primary group">
                Jetzt Job finden
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to="/ueber-uns" className="group flex items-center gap-3 font-semibold text-slate-900 hover:text-teal-600 transition-colors py-3 px-6">
                <span className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center text-teal-600 group-hover:scale-110 transition-transform">
                  <SafeIcon icon={FiPlay} className="ml-0.5" />
                </span>
                Wie es funktioniert
              </Link>
            </div>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-6 pt-12 border-t border-slate-100">
              {[
                { label: 'Vermittelt', value: '2.500+' },
                { label: 'Unternehmen', value: '450+' },
                { label: 'Zufriedenheit', value: '98%' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl font-bold text-slate-900">{stat.value}</div>
                  <div className="text-sm text-slate-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative"
          >
            <div className="relative z-10 rounded-[40px] overflow-hidden shadow-2xl skew-y-0 hover:-rotate-1 transition-transform duration-700">
              {/* IMAGE: Modern Woman in Home Office */}
              <img 
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="Frau im Home Office" 
                className="w-full h-[600px] object-cover"
              />
            </div>
            
            <motion.div 
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity }}
              className="absolute -left-12 top-1/4 glass-card p-5 rounded-2xl hidden md:block z-20"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiCheck} />
                </div>
                <div>
                  <div className="font-bold text-sm">Geprüfte Jobs</div>
                  <div className="text-xs text-slate-500">100% Seriös</div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 5, repeat: Infinity, delay: 1 }}
              className="absolute -right-6 bottom-12 glass-card p-5 rounded-2xl hidden md:block z-20"
            >
              <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                  {[1,2,3].map(i => (
                    <img key={i} className="w-8 h-8 rounded-full border-2 border-white object-cover" src={`https://i.pravatar.cc/150?u=fem${i}`} alt="Avatar" />
                  ))}
                </div>
                <div className="text-xs font-bold text-slate-900">
                  +15 Bewerbungen <br />
                  <span className="text-teal-600 font-normal">in den letzten 2h</span>
                </div>
              </div>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Hero;